import Loader from "./Loader";
import { useNavigate } from "react-router";
import { pageRoutes } from "../routes/PageRoutes";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBussinessProfileData } from "../redux/actions/authActions";
import { pipDeleteToken, pipSaveProfile, pipGetProfile } from "../auth/Pip";
import HeaderLabels from "./HeaderLabels";

const Header = ({ onClick }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoading, bussiness_profile } = useSelector(
    (state) => state?.authReducer
  );
  const [profileData, setProfileData] = useState(pipGetProfile());

  useEffect(() => {
    const dat = pipGetProfile();
    const isDifferentUser = dat && bussiness_profile && Number(dat.id) !== Number(bussiness_profile.id);

    if ((!bussiness_profile || isDifferentUser) && !isLoading) {
      dispatch(getBussinessProfileData());
    }
  }, [dispatch, bussiness_profile, isLoading]);

  useEffect(() => {
    const dat = pipGetProfile();
    if (!bussiness_profile) return;

    const data = {
      id: bussiness_profile?.id ?? dat?.id ?? "",
      name:
        [bussiness_profile?.first_name, bussiness_profile?.last_name]
          .filter(Boolean)
          .join(" ") ||
        dat?.name ||
        "",
      company_name: bussiness_profile?.company_name ?? dat?.company_name ?? "",
      profile_image: bussiness_profile?.profile_image ?? dat?.profile_image ?? "",
      email: bussiness_profile?.email ?? dat?.email ?? "",
    };

    pipSaveProfile(data);
    setProfileData(data);
  }, [bussiness_profile]);

  const profileImageSrc =
    bussiness_profile?.profile_image ||
    profileData?.profile_image ||
    "user_profile.png";

  const displayName =
    [bussiness_profile?.first_name, bussiness_profile?.last_name]
      .filter(Boolean)
      .join(" ") ||
    profileData?.name ||
    "User";

  const onHandleLogout = () => {
    pipDeleteToken();
    navigate(pageRoutes.login);
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <div>

        <div className="ct_dashboard_head">
          <div className="d-flex gap-2 align-items-center">
            <div className="ct_toggle_side" onClick={onClick}>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <HeaderLabels />
          </div>


          <div className="d-flex align-items-center gap-3">
            <a className="ct_pointer" onClick={() => navigate(pageRoutes.notification)}>
              <svg
                width={28}
                height={28}
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.3285 3.46875C11.8727 3.84161 11.5696 4.36886 11.4768 4.95042C11.4387 5.12982 11.3587 5.2977 11.2435 5.44042C11.1332 5.5887 10.9893 5.70866 10.8235 5.79042L9.90184 6.23375C9.16297 6.59684 8.50748 7.10931 7.97684 7.73875C6.34351 9.68708 6.34351 10.5621 6.34351 13.8871C6.34351 15.3921 4.74518 16.7571 4.32518 18.1104C4.06851 18.9154 3.92851 20.7354 6.05184 20.7354H21.8952C22.2055 20.7489 22.5143 20.6847 22.7935 20.5488C23.0717 20.4102 23.312 20.206 23.4935 19.9538C23.6662 19.6994 23.7735 19.4066 23.8085 19.1021C23.8349 18.7908 23.7827 18.478 23.6568 18.1921C23.2368 16.9204 21.5685 15.4038 21.5685 13.8988V11.4138"
                  stroke="#62748E"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.7651 20.7344C17.7686 21.2325 17.6776 21.7272 17.4968 22.1927C17.3011 22.6535 17.0201 23.0731 16.6684 23.4294C16.3127 23.7861 15.8885 24.0672 15.4214 24.2557C14.9542 24.4441 14.4537 24.5361 13.9501 24.526C13.4454 24.5292 12.9453 24.43 12.4801 24.2344C11.5473 23.8439 10.8055 23.1022 10.4151 22.1694C10.2321 21.7134 10.1409 21.2257 10.1468 20.7344"
                  stroke="#62748E"
                  strokeWidth="1.25"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M17.7643 9.30208C19.3752 9.30208 20.681 7.99625 20.681 6.38542C20.681 4.77459 19.3752 3.46875 17.7643 3.46875C16.1535 3.46875 14.8477 4.77459 14.8477 6.38542C14.8477 7.99625 16.1535 9.30208 17.7643 9.30208Z"
                  stroke="#62748E"
                  strokeWidth="1.25"
                />
              </svg>
            </a>
            <div className="ct_right_dropdown dropdown">
              <button
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="d-flex align-items-center gap-2">
                  <img
                    alt="Profile"
                    className="ct_img_30"
                    src={profileImageSrc}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "user_profile.png";
                    }}
                  />
                  <div className="text-start">
                    <small className="ct_text_clr_62748E ct_fs_16 text-nowrap">
                      {displayName}
                    </small>
                  </div>
                </div>
                <i className="fa-solid fa-angle-down ms-auto" />
              </button>
              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <div className="overflow-hidden ct_user_info">
                    <h6 className="text-truncate ct_fs_14 ct_ff_ProximaNova_semibold mb-1">
                      {profileData?.name ?? ""}
                    </h6>
                    <p className="mb-0 ct_text_para text-truncate ct_fs_14 ct_ff_ProximaNova_regular">
                      {profileData?.company_name ?? ""}
                    </p>
                  </div>
                </li>
                <li onClick={() => navigate(pageRoutes.business_profile)}>
                  <a className="dropdown-item ct_pointer ct_ff_ProximaNova_regular">
                    My Profile
                  </a>
                </li>
                <li onClick={() => navigate(pageRoutes.changePassword)}>
                  <a className="dropdown-item ct_pointer ct_ff_ProximaNova_regular">
                    Change Password
                  </a>
                </li>
                <li onClick={() => navigate(pageRoutes.subscription)}>
                  <a className="dropdown-item ct_pointer ct_ff_ProximaNova_regular">
                    My Subscriptions
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item ct_text_clr_CB0B03 ct_ff_ProximaNova_semibold"
                    href="javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')"
                    data-bs-toggle="modal"
                    data-bs-target="#ct_logout_modal"
                  >
                    <svg
                      className="me-1"
                      width={19}
                      height={19}
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.8066 11.5743L15.8333 9.54766L13.8066 7.521"
                        stroke="#F51B0B"
                        strokeWidth="1.5"
                        strokeMiterlimit={10}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.72656 9.54736H15.7778"
                        stroke="#F51B0B"
                        strokeWidth="1.5"
                        strokeMiterlimit={10}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.3099 15.8332C5.81073 15.8332 2.97656 13.4582 2.97656 9.49984C2.97656 5.5415 5.81073 3.1665 9.3099 3.1665"
                        stroke="#F51B0B"
                        strokeWidth="1.5"
                        strokeMiterlimit={10}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Log Out
                  </a>
                </li>
              </ul>
            </div>
          </div>



        </div>
      </div>


      {/* logout modal */}
      {/* <div
        className="modal fade ct_assets_modal"
        id="ct_logout_modal"
        tabIndex={-1}
        aria-labelledby="ct_logout_modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 pt-0">
              <button
                type="button"
                className="btn-close ct_cloose_btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <div className="modal-body border-0 ">
              <svg
                width={21}
                height={20}
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0117 0C4.51172 0 0.0117188 4.5 0.0117188 10C0.0117188 15.5 4.51172 20 10.0117 20C15.5117 20 20.0117 15.5 20.0117 10C20.0117 4.5 15.5117 0 10.0117 0ZM10.0117 15.9C6.81172 15.9 4.11172 13.3 4.11172 10C4.11172 8.3 4.91172 6.6 6.21172 5.5C6.61172 5.2 7.31172 5.2 7.61172 5.6C8.01172 6.1 7.91172 6.7 7.51172 7.1C6.61172 7.8 6.11172 8.9 6.11172 10.1C6.11172 12.2 7.81172 14 10.0117 14C12.2117 14 13.9117 12.3 13.9117 10.1C13.9117 9 13.4117 7.9 12.5117 7.1C12.1117 6.8 12.0117 6.1 12.4117 5.7C12.8117 5.3 13.4117 5.2 13.8117 5.6C15.1117 6.7 15.9117 8.4 15.9117 10.1C15.9117 13.3 13.2117 15.9 10.0117 15.9ZM10.0117 3.5C10.5117 3.5 11.0117 3.9 11.0117 4.5V8.2C11.0117 8.7 10.5117 9.2 10.0117 9.2C9.51172 9.2 9.01172 8.7 9.01172 8.2V4.5C9.01172 3.9 9.51172 3.5 10.0117 3.5Z"
                  fill="#DC0202"
                />
              </svg>
              <h4 className="text-center mb-4 ct_fw_600">Log Out Account</h4>
              <p className="text-center ct_grey_text">
                Are you sure, you want to logout? once you logout <br /> you
                need to login again.
              </p>
              <div className="modal-footer border-0 justify-content-center">
                <button
                  type="button"
                  className="ct_blue_btn py-2 h-auto"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <a
                  href="javascript:void(0)"
                  onClick={() => onHandleLogout()}
                  type="button"
                  data-bs-dismiss="modal"
                  className="ct_b_red_btn text-white justify-content-center  py-2 h-auto"
                  style={{ borderColor: "rgb(220, 53, 69)" }}
                >
                  Logout
                </a>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div> */}



      {/* new */}

      <div
        class="modal fade"
        id="ct_logout_modal"
        tabindex="-1"
        aria-labelledby="ct_logout_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-body">
              <div class="ct_delete_post_modal p-4">
                <figure>
                  <figcaption>
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="">

                        <h4 class="ct_fs_24 ct_fw_600 ct_text_dark mb-2">
                          Logout
                        </h4>
                        <p class="mb-0 ct_fs_16 ct_fw_400  ct_text_para" >
                          Are you sure you want to disable this Logout? This action cannot be undone.
                        </p>
                      </div>

                      <div data-bs-dismiss="modal">
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>
                  </figcaption>
                </figure>
                <div
                  class="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30"
                >
                  <button
                    type="button"
                    class="ct_orange_transparent_btn ct_h_40 "
                    data-bs-dismiss="modal"
                  >
                    Cancel</button
                  ><a
                    data-bs-dismiss="modal"
                    class="ct_border_radius_5 ct_h_40 ct_orange_btn  text-center ct_pointer"
                    href="javascript:void(0)"
                    onClick={() => onHandleLogout()}
                  >Yes, Logout</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>






      {/* new */}




    </div>
  );
};

export default Header;
